import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import TopBar from "./TopBar";
import { SCREEN_PATHS } from "../../constants";

interface Props {
  children?: JSX.Element;
  forceTopBar?: boolean;
  centerLogo?: boolean;
}

export const NotAuthedLayout = ({
  children,
  forceTopBar,
  centerLogo,
}: Props): JSX.Element => {
  const path = window.location.pathname;
  // don't show TopBar on auth screens
  const showTopBar =
    forceTopBar ||
    (path.substr(0, SCREEN_PATHS.auth.length) !== SCREEN_PATHS.auth &&
      !(path === "/" || path === ""));

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        display: "flex",
        height: "100%",
        overflow: "hidden",
        width: "100%",
      }}
    >
      {showTopBar && <TopBar centerLogo={centerLogo} />}
      <Box
        sx={{
          display: "flex",
          flex: "1 1 auto",
          overflow: "hidden",
          paddingTop: showTopBar ? 8 : 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: "1 1 auto",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              flex: "1 1 auto",
              height: "100%",
              overflow: "auto",
            }}
          >
            {children ? children : <Outlet />}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
